var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("新增部门"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataeRef",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "parentId",
      label: _vm.$t("部门"),
      hasFeedback: ""
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterTreeNode: _vm.filterTreeOption,
      "show-search": "",
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      placeholder: _vm.$t("请选择") + _vm.$t("架构"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      "replace-fields": {
        children: "children",
        key: "id",
        value: "id",
        title: "name"
      }
    },
    model: {
      value: _vm.dataFrom.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "parentId", $$v);
      },
      expression: "dataFrom.parentId"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("部门名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };